// §69 Who is already in LinkedIn Follow-ups (any audience), so nobody is added twice.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const AUDS = ["hiring_manager", "mpc_pitch", "job_seeker"];
const li = (u) => String(u || "").toLowerCase().replace(/^https?:\/\/(www\.)?/, "").replace(/[?#].*$/, "").replace(/\/+$/, "");
let cache = null;
let inflight = null;
const subs = new Set();

const load = () => {
  inflight = Promise.all(AUDS.map((a) => api.get(`/admin/rcc/li/prospects?audience=${a}&limit=1000`).then((r) => r.data?.items || []).catch(() => [])))
    .then((ls) => {
      const all = ls.flat();
      cache = {
        emails: new Set(all.map((p) => String(p.email || "").toLowerCase()).filter(Boolean)),
        lis: new Set(all.map((p) => li(p.linkedin_url)).filter(Boolean)),
        ids: new Set(all.flatMap((p) => [p.si_person_id, p.radar_person_id, p.si_candidate_id]).filter(Boolean)),
      };
      subs.forEach((f) => f(cache));
      return cache;
    });
  return inflight;
};

export const refreshFollowUps = () => load();

export const inFollowUps = (idx, p) => !!idx && (
  (p.email && idx.emails.has(String(p.email).toLowerCase()))
  || [p.linkedin_url, p.profile_url, ...(p.profile_urls || [])].some((u) => /linkedin\.com/i.test(u || "") && idx.lis.has(li(u)))
  || (p.id && idx.ids.has(p.id))
);

export const useFollowUps = () => {
  const [idx, setIdx] = useState(cache);
  useEffect(() => {
    subs.add(setIdx);
    if (!cache && !inflight) load();
    return () => { subs.delete(setIdx); };
  }, []);
  return idx;
};
